import React from 'react';
import { IMessageCard } from './interfaces';
import { Card } from '@mui/material';
import { BORDER_COLOR } from '../../../../../constants';

export const MessageCard: React.FC<IMessageCard> = ({
  children,
  sx,
}): JSX.Element => {
  return (
    <Card
      elevation={0}
      sx={{
        ...sx,
        border: `.5px solid ${BORDER_COLOR}`,
        '& .MuiCardContent-root:last-child': {
          pb: '16px',
        },
      }}
    >
      {children}
    </Card>
  );
};
